import React, { ReactElement } from "react";
import { ActionIcon, Tooltip } from "@mantine/core";
import { IconCalendarPlus } from "@tabler/icons-react";
import { formatCalendarDate } from "../../utils/formatTime";
export default function GoogleCalendarIcon({
  date,
  title,
  description,
}: {
  date: Date;
  title: string;
  description: string;
}): ReactElement {
  function handleClick() {
    window.open(
      `https://calendar.google.com/calendar/render?action=TEMPLATE&text=${title}&dates=${formatCalendarDate(date)}/${formatCalendarDate(date)}&details=${description}`
    );
  }

  return (
    <>
      <Tooltip label={"Add to Google calendar"} withArrow position="right">
        <ActionIcon
          c="var(--mid-dark)"
          bg="inherit"
          onClick={handleClick}
          className="calendar-icon"
        >
          <IconCalendarPlus size={16} />
        </ActionIcon>
      </Tooltip>
    </>
  );
}
